import { useState } from 'react';
import type { PortfolioData, Testimonial } from '../domain/portfolio.types';

function TestimonialCard({ t, i }: { t: Testimonial; i: number }) {
  const [expanded, setExpanded] = useState(false);
  const isLong = t.quote.length > 180; // Truncate threshold

  return (
    <div className="testi-card reveal" style={{ transitionDelay: `${i * 80}ms` }}>
      <div className="quote-mark">"</div>
      
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <p className="quote" style={{
          display: '-webkit-box',
          WebkitLineClamp: expanded ? 9999 : 6,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          marginBottom: isLong ? 12 : 24, // reduce margin if button follows
          transition: 'all 0.3s ease'
        }}>
          {t.quote}
        </p>
        
        {isLong && (
          <div style={{ marginBottom: 24 }}>
            <button 
              onClick={() => setExpanded(!expanded)} 
              style={{ 
                background: 'transparent', 
                border: 'none', 
                color: 'var(--accent)', 
                fontFamily: 'var(--font-mono)', 
                fontSize: 12, 
                fontWeight: 600, 
                cursor: 'pointer', 
                padding: '8px 16px 8px 0',
                margin: '-8px 0',
                letterSpacing: '0.05em',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4
              }}
            >
              {expanded ? 'READ LESS ▴' : 'READ MORE ▾'}
            </button>
          </div>
        )}
      </div>

      <div className="testi-foot" style={{ display: 'block' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: t.linkedin ? 16 : 0 }}>
          <div className="testi-avatar" style={{ overflow: 'hidden', background: t.avatar.startsWith('http') ? 'none' : undefined }}>
            {t.avatar.startsWith('http') ? (
              <img src={t.avatar} alt={t.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              t.avatar
            )}
          </div>
          <div style={{ flex: 1 }}>
            <div className="testi-name">{t.name}</div>
            <div className="testi-role">{t.role}</div>
          </div>
        </div>
        {t.linkedin && (
          <a href={t.linkedin} target="_blank" rel="noopener noreferrer" className="testi-linkedin" title="Read on LinkedIn" style={{ width: '100%', justifyContent: 'center' }}>
            <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
              <rect x="2" y="9" width="4" height="12"></rect>
              <circle cx="4" cy="4" r="2"></circle>
            </svg>
            <span>Read on LinkedIn</span>
          </a>
        )}
      </div>
    </div>
  );
}

export function Testimonials({ data }: { data: PortfolioData }) {
  return (
    <section className="section" id="testi">
      <div className="container">
        <div className="reveal" style={{ marginBottom: 56, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 20 }}>
          <div>
            <div className="section-tag">06 · Words</div>
            <h2 className="section-title">
              Battle-tested <span className="alt">testimonials</span>.
            </h2>
          </div>
        </div>
        <div className="testimonial-track">
          {data.testimonials.map((t, i) => (
            <TestimonialCard key={i} t={t} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
